'use client';

import { ENTERPRISE_COPY, isEnterpriseDistribution } from '@/app/constants';

export const getCustomPlatformLoginErrorMessage = (reason?: string): string | null => {
  switch (reason) {
    case 'CustomPlatformMemberNotFound':
      return ENTERPRISE_COPY.login.memberNotFound;
    case 'CustomPlatformMemberPending':
      return ENTERPRISE_COPY.login.memberPending;
    case 'CustomPlatformCodeInvalid':
      return ENTERPRISE_COPY.login.codeInvalid;
    default:
      return null;
  }
};

export const getRedirectUrl = (searchParams: URLSearchParams, urlPrefix = ''): string => {
  const redirect = searchParams.get('redirect');
  if (!redirect) {
    if (isEnterpriseDistribution) {
      return `${urlPrefix}/team-profile`;
    }
    return `${urlPrefix}/create/character2video`;
  }
  return `${urlPrefix}${decodeURIComponent(redirect)}`;
};
